import axios from 'axios';
import Swal from 'sweetalert2';
import { push } from 'connected-react-router';

export function submitAssessment(candidateId, isSelfSponsored, assessment) {
  return (dispatch) => {
    Swal.fire({
      title: 'Submitting self assessments...',
      html: 'Please wait.  This might take a few seconds.',
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    axios
      .post(`/self-assessment/${candidateId}`, { assessment })
      .then((response) => {
        Swal.close();
        const { status } = response.data;
        if (status === 'SUCCESS') {
          let options;
          if (isSelfSponsored) {
            options = {
              icon: 'success',
              title: 'You can now do one of the following:',
              html: `
              <p>We’re now scheduling your technical assessment automatically.</p>
              <p>
                You’ll receive an email with your booking confirmation shortly.
                You can start your assessment at any time, but once you begin you’ll have a maximum of <strong>3 hours</strong> to complete it.
              </p>
              <hr/>
              <p>
                You can complete your technical assessment in up to 3 sittings, up to a total of <strong>3 hours</strong>. If you need to stop, use <strong>‘End session’</strong> to pause and bank your remaining time, then resume later from your dashboard with a new proctored session. Logging out does not pause the timer.
              </p>
              <p>
                Please keep an eye out for an email from our proctoring provider, <strong>ProctorExam</strong>.<br/>
                If it doesn’t arrive within a few minutes, please check your spam/junk folder or contact us at
                <a href="mailto:contact@competas.com">contact@competas.com</a>.
              </p>
              <p>
                You are welcome to complete your psychometric evaluation at any time.
              </p>
            `,
            };
          } else {
            options = {
              icon: 'success',
              title: 'Self-assessment complete',
              html: `
              <p>We’re now scheduling your technical assessment automatically.</p>
              <p>
                You’ll receive an email with your booking confirmation shortly.
                You can start your assessment at any time, but once you begin you’ll have a maximum of <strong>3 hours</strong> to complete it.
              </p>
              <hr/>
              <p>
                You can complete your technical assessment in up to 3 sittings, up to a total of <strong>3 hours</strong>. If you need to stop, use <strong>‘End session’</strong> to pause and bank your remaining time, then resume later from your dashboard with a new proctored session. Logging out does not pause the timer.
              </p>
              <p>
                Please keep an eye out for an email from our proctoring provider, <strong>ProctorExam</strong>.<br/>
                If it doesn’t arrive within a few minutes, please check your spam/junk folder or contact us at
                <a href="mailto:contact@competas.com">contact@competas.com</a>.
              </p>
              <p>
                You are welcome to complete your psychometric evaluation at any time.
              </p>
            `,
            };
          }

          Swal.fire(options).then(() => {
            dispatch(push('/psychometric'));
          });
        }
      })
      .catch((error) => {
        Swal.close();
        const { data } = error.response;
        if (data.status_code === 102) {
          Swal.fire({
            title: 'Error!',
            text: data.status_message,
            icon: 'error',
          }).then(() => {
            dispatch(push('/login'));
          });
        } else {
          console.error(error);
        }
      });
  };
}
